import type { Due } from '@/entities/shared/due/due';
import { dueState } from '@/entities/shared/due/due-state';
import { REMIND_DAYS } from '@/entities/shared/due/remind-days';
import { daysBetween } from '@/shared/lib/dates/days-between';
import type { IsoDate } from '@/shared/lib/dates/iso-date';
import { today } from '@/shared/lib/dates/today';
import type { Task } from '../schemas/task';
import { isOpenTask } from './is-open-task';

/**
 * An open task's state: waiting before `starts_on`, then by `due_on` and `remind_days` (0 by
 * default: amber only on the day, red once past). No dates, or done: nothing to show.
 */
export function taskDueOf(task: Task, on: IsoDate = today()): Due | null {
  if (!isOpenTask(task)) return null;
  const startsIn = task.starts_on ? daysBetween(on, task.starts_on) : null;
  const waiting = startsIn !== null && startsIn > 0;
  const date = task.due_on ?? (waiting ? task.starts_on : undefined);
  if (!date) return null;
  const days = daysBetween(on, date);
  return {
    date,
    kind: 'task',
    days,
    urgency: dueState(days, task.remind_days ?? REMIND_DAYS.task, startsIn),
    ...(waiting && task.starts_on ? { startsOn: task.starts_on } : {}),
  };
}
